import React from "react";
import { IonItem } from "@ionic/react";
import { useState } from "react";
import Collapsible from "react-collapsible";
import {
  Button_Checkbox_Active,
  Button_Checkbox_Inactive,
  Button_Disclosure_Right_Grey,
  Icon_Radio_Active,
  Icon_Radio_Grey,
} from "@assets/images";
import classNames from "classnames";
import { EvidenceSearchFilter } from "@state/FilterState";

type Props = {
  title: string;
  filterOptions?: EvidenceSearchFilter[];
  singleSelect?: boolean;
  filters?: EvidenceSearchFilter[];
  toggleSelectedOption?: (filter: EvidenceSearchFilter, singleSelect?: boolean) => void;
};

const EvidenceFilterDropdown = (props: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const filtersForGroup = props.filters?.filter((filter) => filter.type === props.title) ?? [];

  const includeDrafts = filtersForGroup.findIndex((filter) => filter.option === "Include Drafts") !== -1;
  const draftsDisplay = filtersForGroup.findIndex((filter) => filter.type === "Drafts") !== -1;

  return (
    <div className="mb-3">
      <Collapsible
        trigger={
          <IonItem
            button
            detail={false}
            className="ion-item-no-padding"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="flex h-13 w-full flex-row items-center justify-between">
              <div className="text-acc-16px font-acc-500 text-grey-90">{props.title}</div>
              <div className="flex flex-row items-center">
                <FiltersForGroupDisplay
                  filtersForGroup={filtersForGroup}
                  includeDrafts={includeDrafts}
                  draftsDisplay={draftsDisplay}
                />
                <img
                  src={Button_Disclosure_Right_Grey}
                  className={classNames("img-no-select size-6", {
                    "-rotate-90": isOpen,
                    "rotate-90": !isOpen,
                  })}
                />
              </div>
            </div>
          </IonItem>
        }
        transitionTime={100}
        transitionCloseTime={100}
      >
        {props.filterOptions?.map((filter) => {
          const isSelected = filtersForGroup.findIndex((_filter) => _filter.option === filter.option) !== -1;

          return (
            <IonItem
              button
              detail={false}
              className="ion-item-no-padding ml-4"
              onClick={() => props.toggleSelectedOption?.(filter, props.singleSelect)}
              key={filter.option}
            >
              <div className="flex h-13 w-full flex-row items-center justify-between">
                <div
                  className={classNames("text-acc-16px text-grey-90", {
                    "font-acc-600 tracking-normal": isSelected,
                  })}
                >
                  {filter.label}
                </div>
                {props.singleSelect ? (
                  <img
                    src={isSelected ? Icon_Radio_Active : Icon_Radio_Grey}
                    className="img-no-select -mr-2 size-11"
                  />
                ) : (
                  <img
                    src={isSelected ? Button_Checkbox_Active : Button_Checkbox_Inactive}
                    className="img-no-select -mr-2 size-11"
                  />
                )}
              </div>
            </IonItem>
          );
        })}
      </Collapsible>
    </div>
  );
};

type FiltersForGroupDisplayProps = {
  filtersForGroup: EvidenceSearchFilter[];
  draftsDisplay: boolean;
  includeDrafts: boolean;
};

const FiltersForGroupDisplay = (props: FiltersForGroupDisplayProps) => {
  if (props.draftsDisplay) {
    return (
      <div className="mr-1 text-acc-16px font-acc-normal text-cta-blue">
        {props.includeDrafts ? "Included" : "Excluded"}
      </div>
    );
  }

  if (props.filtersForGroup.length > 0) {
    return (
      <div className="mr-1 text-acc-16px font-acc-normal text-cta-blue">{`${props.filtersForGroup.length} selected`}</div>
    );
  }

  return null;
};

export default EvidenceFilterDropdown;
